import { useState } from 'react'
import Classnames from 'classnames'

const Unsubscribe = () => {
  const [showConfirm, setConfirm] = useState(false);

  const handleUnsubscribe = () => {}

  return (
    <div className="pt-1">
      <div className='relative overflow-hidden h-9 px-2'>
        <div className={Classnames(
          "h-9",
          {
            "-translate-y-full": showConfirm
          }
        )}>
          <button 
              className={Classnames(
                "shadow-md shadow-black/30 uppercase h-6 text-[10px] font-bold px-4 text-white bg-primary rounded-lg transition-all",
                "mb-",
              )}
              onClick={() => setConfirm(!showConfirm)}
            >unsubscribe</button>
        </div>
          <div className={Classnames(
            "flex items-center gap-2 h-9 transition-all",
            {
              "-translate-y-full": showConfirm
            }
          )}>
            <button
            className={Classnames(
              "shadow-md shadow-black/30 uppercase h-6",
              "text-[10px] font-bold px-4 text-white bg-red-500",
              "rounded-lg transition-all mb-2"
            )}
              onClick={() => setConfirm(!showConfirm)}
            >Cancel</button>

            <button className='text-[12px] mb-0 h-6 text-green-600 font-bold'
              onClick={handleUnsubscribe}
            >Yes, unsubscribe</button>
          </div>
      </div>
    </div>
  )
}

export default Unsubscribe